import { ExternalLink, MonitorDown } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { TOOLBOX_SETUP_GUIDE_URL } from "@/lib/toolbox/bridge";

export interface OpenInToolboxCalloutProps {
  /** What the person was trying to do, e.g. "Grooming runs Claude Code on your computer". */
  reason?: string;
}

/**
 * Shown in a plain browser where a page needs SpecTree Toolbox: what to do
 * instead, and where to learn to install it.
 */
export function OpenInToolboxCallout({ reason }: OpenInToolboxCalloutProps) {
  return (
    <Card data-testid="open-in-toolbox">
      <CardContent className="flex flex-col gap-3 p-6 sm:flex-row sm:items-start sm:gap-4">
        <MonitorDown className="h-6 w-6 shrink-0 text-primary" aria-hidden="true" />
        <div className="space-y-2">
          <h2 className="text-base font-semibold">Open in SpecTree Toolbox</h2>
          <p className="text-sm text-muted-foreground">
            {reason ?? "These tools run Claude Code on your computer, so they work only inside the SpecTree Toolbox desktop app."}{" "}
            Open SpecTree Toolbox and sign in to SpecTree there. Everything you do in the app is saved in SpecTree.
          </p>
          <a
            href={TOOLBOX_SETUP_GUIDE_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline"
          >
            How to install SpecTree Toolbox
            <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
          </a>
        </div>
      </CardContent>
    </Card>
  );
}
